import { useTranslation } from 'next-i18next'
import React, { useState } from 'react'

import { css } from '@emotion/react'

import { ParkingDetails } from '@/service'
import CustomReveal from '@/components/common/CustomReveal'
import TextWithButton from '@/components/common/TextWithButton'

import ToggleView from '@/components/common/ToggleView'
import Title from '@/components/common/Title'

import { mediaDown, mediaUp } from '@/styles/media'
import { spacingSection } from '@/styles/mixins'
import { H2Styles } from '@/styles/typography'
import { Grid } from '@/styles/grid'

import StepByStepList from './StepByStepList'

interface Props {
  details: ParkingDetails
}

function StepByStepSection(props: Props) {
  const { details } = props
  const { t } = useTranslation('parkings')
  const [activeView, setActiveView] = useState(0)

  return (
    <CustomReveal>
      <>
        <div css={container}>
          {details.stepByStepFlows.length > 0 && (
            <>
              <Title
                text={t('stepByStep.title')}
                css={titleSteps}
                id={'step-by-step-section'}
              />
              <ToggleView
                toggleView={view => setActiveView(view)}
                active={activeView}
                views={details.stepByStepFlows}
                css={toggleViewSteps}
              />
            </>
          )}
          <Grid>
            <StepByStepList steps={details.stepByStepFlows[activeView]} />
            <TextWithButton
              text={t('stepByStep.buttonMore')}
              button={t('stepByStep.buttonCheck')}
              link={{ pathname: '/faq' }}
            />
          </Grid>
        </div>
      </>
    </CustomReveal>
  )
}

const container = css`
  ${spacingSection};
`

const titleSteps = css`
  ${H2Styles};

  ${mediaUp('lg')} {
    font-size: 36px;
    line-height: 1.33;
  }
`

const toggleViewSteps = css`
  padding: 18px 0 40px;

  ${mediaDown('md')} {
    flex-direction: column;

    button {
      margin-top: 10px;

      &:first-of-type {
        margin-top: 0;
      }
    }
  }

  ${mediaUp('lg')} {
    padding: 40px 0 80px;
  }
`

export default StepByStepSection
